module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.organizations')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "organizations",
      "columns": ['name', 'owner'],
      "sModel": "organization"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ebe1eb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organization/OrganizationList.vue
// module id = 1172
// module chunks = 2